import { createElement } from 'react';

const isUrlObject = (href)=>{
    return typeof href === 'object' && 'href' in href;
};
const Link = ({ className, disabled, label, role = 'link', anchorComponent: AnchorComponent, ...props })=>{
    const href = isUrlObject(props.href) ? props.href.href : props.href;
    const anchorProps = {
        ...props,
        'aria-disabled': disabled,
        'aria-label': label,
        className,
        href: disabled ? '' : href,
        onClick: !disabled ? props.onClick : undefined,
        role
    };
    return /*#__PURE__*/ createElement(AnchorComponent ?? 'a', anchorProps, props.children);
};

export { Link, Link as default };
//# sourceMappingURL=Link.es.js.map
